import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Auto123ResolverService, GtagsResolverService } from './data-resolvers.service';
import { CotizadorAutoComponent } from './cotizador-auto/cotizador-auto.component';
import { CotizadorHogarComponent } from './cotizador-hogar/cotizador-hogar.component';
import { CotizadorTecnologiaComponent } from './cotizador-tecnologia/cotizador-tecnologia.component';
import { LandingComponent } from './landing/landing.component';
import { CotizadorBiciComponent } from './cotizador-bici/cotizador-bici.component';
import { CotizadorTecnologiaOpc1Component } from './cotizador-tecnologia-opc1/cotizador-tecnologia-opc1.component';
import { CotizadorBiciOpc1Component } from './cotizador-bici-opc1/cotizador-bici-opc1.component';
import { CotizadorBiciOpc2Component } from './cotizador-bici-opc2/cotizador-bici-opc2.component';
const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'cotizador-auto',
    component: CotizadorAutoComponent,
    runGuardsAndResolvers: 'always',
    resolve: {
      token123: Auto123ResolverService
    }
  },
  {
    path: 'hogar',
    component: CotizadorHogarComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia',
    component: CotizadorTecnologiaComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia-gracias',
    component: CotizadorTecnologiaComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia-nps',
    component: CotizadorTecnologiaComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia-unsuscribe',
    component: CotizadorTecnologiaComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bici',
    component: CotizadorBiciComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bici-gracias',
    component: CotizadorBiciComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bici-nps',
    component: CotizadorBiciComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bici-unsuscribe',
    component: CotizadorBiciComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia1',
    component: CotizadorTecnologiaOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia1-gracias',
    component: CotizadorTecnologiaOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia1-nps',
    component: CotizadorTecnologiaOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'tecnologia1-unsuscribe',
    component: CotizadorTecnologiaOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-suma-asegurada',
    component: CotizadorBiciOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-suma-asegurada-gracias',
    component: CotizadorBiciOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-suma-asegurada-nps',
    component: CotizadorBiciOpc1Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-suma-asegurada-unsuscribe',
    component: CotizadorBiciOpc1Component,
    runGuardsAndResolvers: 'always'
  },

  {
    path: 'bicicletas-planes',
    component: CotizadorBiciOpc2Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-banco-gracias',
    component: CotizadorBiciOpc2Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-planes-nps',
    component: CotizadorBiciOpc2Component,
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'bicicletas-planes-unsuscribe',
    component: CotizadorBiciOpc2Component,
    runGuardsAndResolvers: 'always'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
